
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"stroke":"#000","stroke-linecap":"round","stroke-width":"1.6","d":"M16.099 16.098L26.022 6.5 16.1 16.098 6.37 6.5l9.729 9.598zm0 0l9.53 9.402-9.53-9.402L6.378 25.5l9.721-9.402z"}})])
      }
    
      }
    